import { render, staticRenderFns } from "./alarm-radio-dialog.vue?vue&type=template&id=02670476&scoped=true&"
import script from "./alarm-radio-dialog.vue?vue&type=script&lang=js&"
export * from "./alarm-radio-dialog.vue?vue&type=script&lang=js&"
import style0 from "./alarm-radio-dialog.vue?vue&type=style&index=0&id=02670476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02670476",
  null
  
)

export default component.exports